function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.7742 16.7419V6.17579C15.7745 6.05115 15.7376 5.92926 15.6681 5.82574C15.5987 5.72221 15.5 5.64175 15.3846 5.59467L13.2712 4.72651V4.18603C13.489 4.04964 13.6565 3.84608 13.7485 3.60607C13.8404 3.36607 13.8518 3.10267 13.7808 2.85564C13.7099 2.60862 13.5605 2.39139 13.3552 2.23676C13.1499 2.08213 12.8999 1.9985 12.6428 1.9985C12.3858 1.9985 12.1358 2.08213 11.9305 2.23676C11.7252 2.39139 11.5758 2.60862 11.5049 2.85564C11.4339 3.10267 11.4453 3.36607 11.5372 3.60607C11.6291 3.84608 11.7967 4.04964 12.0145 4.18603V4.21019L11.492 3.99563C11.4625 3.98339 11.4316 3.97479 11.4 3.97003C11.3736 3.96364 11.3469 3.95905 11.32 3.95627C11.2748 3.95131 11.2293 3.95131 11.1841 3.95627C11.1544 3.95662 11.1248 3.96044 11.096 3.96763L8.0326 4.77323C7.89833 4.80861 7.77955 4.88745 7.6948 4.99744C7.61005 5.10743 7.5641 5.24238 7.56412 5.38123V10.6516L7.44556 10.6284H7.43644C7.36307 10.6189 7.28859 10.6228 7.2166 10.6398L3.88044 11.404C3.74163 11.4352 3.61764 11.5129 3.52894 11.6241C3.44024 11.7353 3.39215 11.8735 3.3926 12.0158V16.7419H2.6302C2.28319 16.7419 2.00188 17.0232 2.00188 17.3702C2.00188 17.7172 2.28319 17.9985 2.6302 17.9985H17.371C17.718 17.9985 17.9993 17.7172 17.9993 17.3702C17.9993 17.0232 17.718 16.7419 17.371 16.7419H15.7742ZM11.8804 16.7419V5.51339L14.5177 6.59643V16.7419H11.8804ZM12.6428 3.25771C12.6286 3.25771 12.6147 3.25349 12.6028 3.24558C12.591 3.23767 12.5818 3.22642 12.5763 3.21327C12.5709 3.20011 12.5694 3.18563 12.5722 3.17167C12.575 3.1577 12.5819 3.14487 12.5919 3.1348C12.602 3.12473 12.6148 3.11788 12.6288 3.1151C12.6428 3.11232 12.6572 3.11374 12.6704 3.11919C12.6835 3.12464 12.6948 3.13387 12.7027 3.14571C12.7106 3.15755 12.7148 3.17147 12.7148 3.18571C12.7148 3.2048 12.7072 3.22309 12.6937 3.23658C12.6802 3.25007 12.6619 3.25767 12.6428 3.25771ZM10.6246 5.39179V11.2526L8.82108 10.8985V5.86539L10.6246 5.39179ZM7.98668 16.7419V12.0158L10.6246 12.5329V16.7419H7.98668ZM6.73004 12.04V16.7419H4.65004V12.5169L6.73004 12.04Z",
  fill: "#5F6972"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6022 7.80915V6.52051L13.8588 7.03251V7.80915H12.6022Z",
  fill: "#5F6972"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8592 8.60916H12.6026V9.8978H13.8592V8.60916Z",
  fill: "#5F6972"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.71725 14.1165V12.8279L9.9739 13.0679V14.1165H8.71725Z",
  fill: "#5F6972"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97427 14.9165H8.71764V16.2051H9.97427V14.9165Z",
  fill: "#5F6972"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8592 10.6977H12.6026V11.9864H13.8592V10.6977Z",
  fill: "#5F6972"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8592 12.7862H12.6026V14.0749H13.8592V12.7862Z",
  fill: "#5F6972"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8592 14.8755H12.6026V16.1642H13.8592V14.8755Z",
  fill: "#5F6972"
});

const SvgLarge = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLarge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Large.bd04dcbc.svg";
export { ForwardRef as ReactComponent };